import type { LegalDocumentContent } from './types';

/** Canonical IAP terms for LuvLust (iOS + Android). Mirrors in-app drawer termsScreen (en.json). */
export const termsAppContent: LegalDocumentContent = {
  title: 'Terms & Conditions',
  intro:
    'These terms apply to the LuvLust app and one-time in-app purchases made through the Apple App Store or Google Play Store.',
  sections: [
    {
      title: '1. Acceptance of Terms',
      paragraphs: [
        'By downloading, installing, or using our app, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use the app.',
      ],
    },
    {
      title: '2. Contracting the Services',
      paragraphs: [
        'To use premium services in LuvLust, you must be of legal age and download the app from the Apple App Store or Google Play Store.',
        'When you first open the app, you may optionally answer questions related to your preferences. You can change this information at any time in the app settings.',
        'LuvLust includes a free version with limited content so you can try the app before purchasing.',
        'To unlock additional premium content, you may purchase individual packs or bundle packs through one-time in-app purchases (IAP). Payments are processed by Apple or Google through your app store account.',
        'You should also review the terms of the store from which you downloaded the app:',
        'https://play.google.com/intl/en_us/about/play-terms/',
        'https://www.apple.com/legal/internet-services/itunes/',
      ],
    },
    {
      title: '3. Price and Period of Validity',
      paragraphs: [
        'LuvLust will inform you of the price of each product before you complete a purchase, through the app store and within the app.',
        'Prices, unless expressly stated otherwise, do not include communication costs or other ancillary charges.',
        'Prices are shown in your local currency as determined by the app store. Prices for new purchases may change over time but will not affect purchases you have already completed.',
      ],
    },
    {
      title: '4. Purchase Options',
      paragraphs: [
        'LuvLust offers one-time in-app purchases for permanent access to premium content. Available packs may include:',
      ],
      listItems: [
        'Individual mode packs (e.g. dares, stories, quiz, Never Have I Ever)',
        'All Dares bundle',
        'Unlock All bundle (full premium access)',
        'Daily Spark pack',
        'The specific packs offered may vary. The price and content included in each pack are shown before you confirm your purchase.',
      ],
    },
    {
      title: '5. Payment Methods and Security',
      paragraphs: [
        'Payments are processed by Apple (App Store) or Google (Play Store) through your app store account. We do not have access to your payment information and do not store such information.',
        'Apple App Store terms: https://www.apple.com/legal/internet-services/itunes/',
        'Google Play terms: https://play.google.com/intl/en_us/about/play-terms/',
      ],
    },
    {
      title: '6. Applicable Taxes',
      paragraphs: [
        'All prices shown are final at the time of purchase, subject to applicable taxes as determined by the app store. Where appropriate, you will be informed of any price change before completing a new purchase.',
      ],
    },
    {
      title: '7. Price Changes',
      paragraphs: [
        'LuvLust reserves the right to modify prices at any time for new purchases. For one-time purchases, the price charged is the price displayed at the time you confirm the purchase. Once completed, the amount you paid will not be affected by subsequent price changes.',
      ],
    },
    {
      title: '8. Invoicing',
      paragraphs: [
        'Once payment has been made, Apple or Google provides the corresponding receipt or proof of purchase for the transaction.',
      ],
    },
    {
      title: '9. Duration of Access',
      paragraphs: [
        'One-time purchases provide permanent access to the premium content included in the purchased pack. The charge is made only once, and no further billing or renewal will occur.',
        'Access remains valid indefinitely, tied to the Apple ID or Google account used at the time of purchase.',
        'If you change devices or reinstall the app, you can restore your purchases using the Restore Purchases option, provided you use the same app store account.',
        'Refund requests are subject to the refund policies of Apple or Google.',
      ],
    },
    {
      title: '10. Lifetime Purchase Terms',
      listItems: [
        'Permanent Access: A one-time purchase provides ongoing access to the content included in the purchased package. No recurring charges apply.',
        'Scope of Access: The content included is defined at the time of purchase. LuvLust may add new content or features; access to new additions may require a separate purchase.',
        'Non-Transferable: Purchases are tied to your Apple ID or Google account used at the time of purchase and cannot be transferred to another account.',
        'Refund Policy: Refund requests are subject to the refund policies of the Apple App Store or Google Play Store.',
        'Restore Purchases: If you change devices or reinstall the app, purchases can be restored through the Restore Purchases option with the same app store account.',
      ],
    },
    {
      title: '11. Contact',
      paragraphs: ['Questions about these terms: starlitapps.dev@gmail.com'],
    },
  ],
};
